import { UserDetailsPage } from "~/domain/common";

export function DsmUserDetailsPage() {
  return <UserDetailsPage />;
}
